<template>
  <div>
    <Header title="服務鈴監控" ref="rHeader" />

    <div class="main">
      <!-- {{ sum() }} -->
      <!-- {{ bellData }} -->
      <el-row :gutter="0">
        <el-col
          :xs="24"
          :sm="8"
          :md="6"
          :lg="6"
          :xl="6"
          v-for="bd in sum()"
          :key="bd.key"
        >
          <div>
            <el-card
              shadow="never"
              class="yellow"
              style="margin: 0.5rem; background-color: #333; color: white"
            >
              <div
                slot="header"
                style="text-align: center; padding-top: 1rem; height: 12rem"
                @click="cmdClear(bd.tblid)"
              >
                <el-badge :value="bd.Qty">
                  <i class="el-icon-bell" style="font-size: 6rem"></i>
                </el-badge>
                <div style="font-size: 2rem; line-height: 3rem">{{ bd.tblid }}</div>

                <div style="font-size: 2rem; line-height: 3rem">
                  {{ bd.msg }}
                </div>
              </div>

              <div style="text-align: center; font-size: 1.5rem">
                {{ parseInt(bd.firstMinute) }} min
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <van-tabbar fixed placeholder>
      <van-button type="primary" size="large" :loading="loading"
        >最後更新時間 {{ time }}</van-button
      >
    </van-tabbar>

    <audio id="mySound" :src="mp3.m1"></audio>
    <audio id="closeSound" :src="mp3.m2"></audio>
  </div>
</template>
<style scoped>
.empty-seat {
  color: #5237eb;
  background-color: yellow;
}
</style>
<script>
export default {
  data() {
    return {
      bellData: [],
      time: "",
      loading: false,
      oldData: [],
      mp3: {
        m1: require("@/assets/bell.mp3"),
        m2: require("@/assets/close.mp3"),
      },
      timer: null,
    };
  },
  async mounted() {
    console.log("BKBell.monted1");
    this.gMsgbox("請確認開啟音效").then(() => {
      this.playMp3();
      this.init();
    });
  },
  methods: {
    playMp3() {
      console.log("play mp3");
      document.getElementById("mySound").currentTime = 0;
      document.getElementById("mySound").play();
    },
    async init() {
      await this.refresh();
      // clearInterval(this.timer);
      
      // console.log("timer1" , this.timer);
      this.timer = setInterval(async () => {
        this.refresh();
      }, 1000 * 3);
      // console.log("timer2" , this.timer);
      // this.timer =  setInterval(async () => {
      //   await  this.refresh();
      // }, 1000 * 5);
    },
    alertNewMsg(newData) {
      return new Promise((resolve) => {
        var diff = [];
        newData.forEach((n) => {
          var found = this.bellData.find((o) => o.key == n.key);
          if (!found) {
            diff.push(n);
          }
        });

        if (diff.length > 0) {
          console.log(this.now(), "diff", diff);
          diff.forEach((n) => {
            setTimeout(() => {
              this.gMsg(n.tblid + ":" + n.msg);
            }, 300);
          });

          this.playMp3();
        }

        this.bellData = newData;
        resolve();
      });
    },

    async refresh() {
      this.loading = true;
      var res = await this.apiGetBellData();
      await this.alertNewMsg(res.data);
      this.time = this.now();
      this.loading = false;
    },
    sum() {
      var list = this.gGroupBy(this.bellData, "tblid");
      var output = [];
      list.forEach((element) => {
        var found = this.bellData.findLast((r) => r.tblid == element);
        if (found) {
          found.Qty = this.bellData.filter((r) => r.tblid == found.tblid).length;
          output.push(found);
          found.firstMinute = this.bellData[0].diff; //第一個服務鈴等候的時間
        }
      });
      return output;
    },
    cmdClear(tblid) {
      var msg = "清除服務鈴:" + tblid;
      this.gSure(msg)
        .then(async () => {
          // this.msg("確認");
          var query = { tblid: tblid };
          var res = await this.apiCloseBell(query);
          console.log(res);
        })
        .catch(() => {
          // this.msg("取消");
        });
    },
  },
};
</script>
